import { AlertDialog } from "radix-ui";

const ConfirmPopupMessage = ({ children, color }: { children: string; color: string }) => {
  return (
    <AlertDialog.Description
      asChild
      className="box-border p-[10px_15px_40px_15px]"
    >
      <div
        className="whitespace-pre-line text-[14px] font-normal leading-[1.5]"
        style={{ color }}
      >
        {children}
      </div>
    </AlertDialog.Description>
  );
};

export default ConfirmPopupMessage;
